import { formatDate } from '@fifa-bsm/bo-frontend-shared/filters';
import { json } from '@fifa-bsm/bo-frontend-shared/filters';

export const filters = {
    json,
    formatDate,
};

export const registerFilters = (app) => {
    app.config.globalProperties.$json = json;
    app.config.globalProperties.$formatDate = formatDate;
};
